export default __webpack_public_path__ + "static/media/icn-cobotics-cadastro-sensores.431e2055.svg";